import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { FaFilePdf } from 'react-icons/fa';

const GenereMandat = ({ appelCotisationId, go, setGo, visible }) => {

    const url = localStorage.getItem('url');
    const smallurl = localStorage.getItem('smallurl');

    // download pdf src = url + value
    const downloadPdf = (value) => {
        fetch(smallurl + value)
            .then(response => response.blob())
            .then(blob => {
                // console.log(blob);
                const pdfurl = window.URL.createObjectURL(
                    new Blob([blob]),
                );
                // console.log(url);
                const link = document.createElement('a');
                link.href = pdfurl;
                link.setAttribute(
                    'download',
                    `FFC_mandat_sepa_.pdf`,
                );
                document.body.appendChild(link);
                link.click();
                link.parentNode.removeChild(link);
            });
    }

    useEffect(() => {
        if (go) {
            genere();
            setGo(false);
        }
    }, [go]);

    const genere = () => {
        // if (window.confirm(`Voulez-vous générer le pdf ?`)) {

        // fetch(`${url}SendCotisation/${row.adherent_id}/${code}`)
        fetch(`${url}GenereMandatSepa/${appelCotisationId}`)
            .then(response => response.json())
            .then(data => {
                downloadPdf(data.data)
            })
            .catch(error => console.error('Erreur:', error));
        // }
    }

    const handlePdf = (e) => {
        e.stopPropagation();
        genere();
    }

    return (
        <>
            {visible !== false && <Button variant="outline-danger" onClick={(e) => handlePdf(e)}><FaFilePdf /></Button>}
        </>
    );
}

export default GenereMandat;
